import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M2.667 4c0 .666.666 1.333 1.333 1.333h1.333l4.8 10.133-1.733 3.2c-.933 1.733.267 4 2.4 4h14.666c.667 0 1.334-.667 1.334-1.333 0-.667-.667-1.334-1.334-1.334h-14.8l1.467-2.666H22c.933 0 1.866-.534 2.267-1.334l4.8-8.666c.666-.934 0-2-1.067-2H8.267l-.934-1.867c-.133-.533-.666-.8-1.2-.8H4c-.667 0-1.333.667-1.333 1.333z"
        fill={props?.isActive ? "#C06E35" : "rgba(0, 0, 0, 0.4)"}
      />
      <Path
        d="M8 26.667C8 25.2 9.2 24 10.667 24c1.466 0 2.666 1.2 2.666 2.667 0 1.466-1.2 2.666-2.666 2.666A2.674 2.674 0 018 26.667zM21.333 26.667C21.333 25.2 22.533 24 24 24c1.466 0 2.666 1.2 2.666 2.667 0 1.466-1.2 2.666-2.666 2.666a2.674 2.674 0 01-2.667-2.666z"
        fill={props?.isActive ? "#935428" : "rgba(0, 0, 0, 0.4)"}
      />
      <Path
        d="M22.497 10.637L20.21 8.182c-.339-.363-.763-.09-.763.273v1.637h-5.932c-.508 0-.847.363-.847.909 0 .545.339.909.847.909h5.932v1.636c0 .364.424.636.763.364l2.373-2.546c.085-.182.085-.545-.085-.727z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
